<template>
    <div class="DriverCreateModal">
        <h1>Add Driver</h1>

        <p class="errorMessage" v-if="submitError">{{ submitError }}</p>

        <div class="main">
            <DriverForm
                ref="driverForm"
                v-bind.sync="driver"
                :di_type.sync="driver.driverInfo.type"
                :di_employeeCode.sync="driver.driverInfo.employeeCode"
                :di_driverLicense.sync="driver.driverInfo.driverLicense"
                :di_rate.sync="driver.driverInfo.rate"
                :di_hiredAt.sync="driver.driverInfo.hiredAt"
                :di_medicalExpireAt.sync="driver.driverInfo.medicalExpireAt"
                :di_tags.sync="driver.driverInfo.tags"
                :di_dispatchNotificationChannels.sync="driver.driverInfo.dispatchNotificationChannels"
            />
        </div>

        <div class="actions">
            <Button class="link" @click="handleCancel">Cancel</Button>
            <Button class="primary" @click="handleCreate" :disabled="submitPending">Save</Button>
        </div>
    </div>
</template>

<script>
import DriverForm from '@/views/company/driver/components/DriverForm';
import driverCreateMixin from '@/mixins/driverCreateMixin';

export default {
    name: 'DriverCreateModal',

    mixins: [driverCreateMixin],

    components: { DriverForm },

    props: {
        onDriverCreated: { type: Function, required: true },
    },

    mounted() {
        this.$analytics.trackModalView(this.$options.name);
    },

    methods: {
        async handleCreate() {
            this.$analytics.trackButtonClick(this.$options.name, 'save', {
                model_type: 'driver',
                model_action: 'create',
            });

            const newDriver = await this.createDriver();
            if (newDriver) {
                this.onDriverCreated(newDriver);
                this.$emit('close');
            }
        },

        handleCancel() {
            this.$analytics.trackButtonClick(this.$options.name, 'cancel', {
                model_type: 'driver',
                model_action: 'create_cancel',
            });

            this.$emit('close');
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.DriverCreateModal {
    @extend %modal;

    .main {
        max-height: 60vh;
        overflow-y: auto;
        margin: 1rem 0;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
    }

    .errorMessage {
        margin: 1rem 0;
        color: $red-color;
        text-align: center;
    }
}
</style>
